var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3588_87408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 23.5C0.724142 23.5 0.5 23.2759 0.5 23V18C0.5 17.7241 0.724142 17.5 1 17.5H23C23.2759 17.5 23.5 17.7241 23.5 18V23C23.5 23.2759 23.2759 23.5 23 23.5H1Z",
    stroke: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 0.5H23C23.2759 0.5 23.5 0.724142 23.5 1V6C23.5 6.27586 23.2759 6.5 23 6.5H1C0.724142 6.5 0.5 6.27586 0.5 6V1C0.5 0.724142 0.724142 0.5 1 0.5Z",
    stroke: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 15H1C0.724142 15 0.5 14.7759 0.5 14.5V9.5C0.5 9.22414 0.724142 9 1 9H23C23.2759 9 23.5 9.22414 23.5 9.5V14.5C23.5 14.7759 23.2759 15 23 15Z",
    stroke: "#808080"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3588_87408"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.12f4700a0960a788fb7e4d37fd8ded5b.svg";
export { ForwardRef as ReactComponent };